import { useEffect, useState } from 'react';

const LS_KEY = 'professya_large_text';
const HTML_CLASS = 'large-text-mode';

export function AccessibilityToggle() {
  const [enabled, setEnabled] = useState(() => {
    try { return localStorage.getItem(LS_KEY) === '1'; } catch { return false; }
  });

  useEffect(() => {
    const el = document.documentElement;
    if (enabled) {
      el.classList.add(HTML_CLASS);
      try { localStorage.setItem(LS_KEY, '1'); } catch { /* ignore */ }
    } else {
      el.classList.remove(HTML_CLASS);
      try { localStorage.removeItem(LS_KEY); } catch { /* ignore */ }
    }
  }, [enabled]);

  // Apply on mount from persisted state
  useEffect(() => {
    if (enabled) document.documentElement.classList.add(HTML_CLASS);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <button
      type="button"
      onClick={() => setEnabled(v => !v)}
      aria-pressed={enabled}
      aria-label={enabled ? 'Desativar texto grande' : 'Ativar texto grande (A+)'}
      title={enabled ? 'Texto grande ativado' : 'Ativar texto grande'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.3rem',
        padding: '0.3rem 0.65rem',
        background: enabled ? 'var(--petrol)' : 'transparent',
        border: `1px solid ${enabled ? 'var(--petrol)' : 'var(--line-medium)'}`,
        borderRadius: 'var(--radius-pill)',
        cursor: 'pointer',
        fontFamily: 'var(--font-body)',
        fontSize: '13px',
        fontWeight: 700,
        color: enabled ? '#fff' : 'var(--text-muted)',
        transition: 'all var(--transition-fast)',
        lineHeight: 1,
      }}
    >
      <span aria-hidden="true" style={{ fontSize: '1rem', fontWeight: 800 }}>A</span>
      <span aria-hidden="true" style={{ fontSize: '0.75rem', fontWeight: 600, marginTop: '1px' }}>+</span>
    </button>
  );
}
